import Vue from 'vue'

import { createAuth0Client } from '@auth0/auth0-spa-js'

import { RecCache } from '@/rec-cache/rec-cache'
import { WobClient } from '@/wob-client/wob-client'
import { WobNamespaces } from '@/wob-client/wob-client-namespaces'
import {
  WobUpAggregators,
  WobDownAggregators,
} from '@/vue-wob-cache/vue-wob-aggregators'
import { geoCoordinateParser } from '@/wob-client/wob-client-geo-coordinate-parser'
// TODO refactor/remove after testing...
import { /* Alarms, */ ExceptionEvent } from './vue-wob-alarms'
import { Iris } from '@/rec-cache/rec-cache-types'

// import { IndexSelector } from '@/rec-cache/rec-cache-index-selector'

// import { Test } from '@/rec-cache/test'

export default {
  async install(vue) {
    console.log('vue-wob-cache.vue-wob-cache.install')

    // Check if a user is already logged in and set token accordingly.
    // TODO moved to be triggered by App
    // const token = this.$auth?.isAuthenticated
    //   ? this.$auth.getTokenSilently()
    //   : null

    // console.log('vue-wob-cache.vue-wob-cache.install.token', token)

    const wobClient = new WobClient()
    const recCache = new RecCache({
      namespaces: WobNamespaces,
      upAggregators: WobUpAggregators,
      downAggregators: WobDownAggregators,
      client: wobClient,
      geoCoordinateFn: geoCoordinateParser,
    })
    // TODO temporary sign in and initialization...
    // wobClient.signIn(
    //   'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJ3b2JhcCI6Imh0dHBzOi8vd2Vib2ZidWlsZGluZ3MuY29tL29udG9sb2d5L1N5c2FkbSIsImlhdCI6MTY1MzY4MDQwMSwiZXhwIjoxNjg0Nzg0NDAxfQ.VTClt5z9KRoKdZoyt764PkH57hanRzpqb-MFN-DbAkPqo7PlErPIwjwsyh4Ncee-Bffh8Wefq_NNHXtS_bDjnDA5U08cFx4_MqW15OgoMoh1jCcJnzIq6J0mBdeLypkqS_Yb9yMi6BXWvF5Ney7VKmXCm7IzN1EVyLrvczl0093qhFc-sFhBOxNWcekJnZ2IS_RsghQHVCw2qJcYVgp2Jv_0Zz6JCHJchxp7LjdBUACcPDY3vZ0HlM-plWv0TivBvpeVmdUz15Sx8nA6S65Xamb1MbqsCPpKNWse3P0ZDf3Riqci5I-SfPd4UdKoS1j7qqYetvLnwsj3gb3X9PE7IA'
    // )
    // wobClient.readAllRequest()

    recCache.index = {}
    recCache.geoCoords = {}
    recCache.types = {}

    // Alarm and exception application. Written in front end for now.
    // TODO refactor/remove after testing...
    // recCache.alarms = {}
    // recCache.exceptions = {}
    // recCache.impacts = {}

    // Variables for second iteration of alarms and exceptions application.
    recCache.exceptionEvents = {}
    recCache.openExceptions = {}
    recCache.activeAlarms = {}
    recCache.alarmingAssets = {}
    recCache.impactedAssets = {}

    const reactiveCache = new Vue({
      data() {
        return {
          recCache,
        }
      },

      async created() {
        // TODO add try catch
        console.log(
          'vue-wob-cache.vue-wob-cache.install.reactive-cache.created'
        )
        const auth0 = await createAuth0Client({
          domain: 'webofbuildings.eu.auth0.com',
          clientId: '4suSZAqIRYd0qiPdW8IqwAQ1rqD3yg3Q',
        })
        Object.defineProperty(this.recCache, 'auth0', { value: auth0 })

        console.log(
          'vue-wob-cache.vue-wob-cache.install.reactive-cache.created.auth-client',
          auth0
        )

        // TODO the browser doesnt seem to remember that a previous login was undertakne.
        // Most likely requires use of cookies, right now the tokens are in memory.
        // If changed to cookies this would be where a access token is fetched silently (if authenticated).
        const isAuthenticated = await auth0.isAuthenticated()
        console.log(
          'vue-wob-cache.vue-wob-cache.install.reactive-cache.created.is-authenticated',
          isAuthenticated
        )
        if (isAuthenticated) {
          this.recCache.client.isAuthenticated = true
          const accessToken = await auth0.getTokenSilently({
            authorizationParams: {
              audience: 'https://api.webofbuildings.com',
            },
          })
          this.recCache.client.accessToken = accessToken
          console.log(
            'vue-wob-cache.vue-wob-cache.install.reactive-cache.created.access-token',
            accessToken
          )

          // Read the user details from the ID token.
          this.recCache.client.user = await auth0.getUser()

          // Change token, flush cache databases and start caching.
          this.recCache.client.setToken(accessToken)
        }
        // TODO the read all must be on the REC cache, not on th e WoB client.
        this.recCache.client.readAllRequest()
      },
    })

    // The login and logout functions are defined as properties on the REC cache.
    Object.defineProperty(reactiveCache.recCache, 'login', {
      // TODO add try-catch
      value: async function () {
        // TODO is this chjeck really necessary, if so, can it be based on WoB client is autheticated property?
        const isAuthenticated = await this.auth0.isAuthenticated()
        if (isAuthenticated) return
        await this.auth0.loginWithPopup({
          authorizationParams: {
            audience: 'https://api.webofbuildings.com',
          },
        })
        this.client.isAuthenticated = true
        const accessToken = await this.auth0.getTokenSilently({
          authorizationParams: {
            audience: 'https://api.webofbuildings.com',
          },
        })
        // Read the user details from the ID token.
        this.client.user = await this.auth0.getUser()

        // TODO define in WoB Client... togetehr with all other auth properties.
        Object.defineProperty(this.client, 'accessToken', {
          value: accessToken,
        })
        console.log(
          'vue-wob-cache.vue-wob-cache.install.reactive-cache.methods.login.token',
          accessToken
        )
        // Change token, flush cache databases and start caching.
        // TODO the read all must be on the REC cache, not on th e WoB client.
        this.client.setToken(accessToken)
        this.clear()
        this.client.readAllRequest()
      },
    })

    Object.defineProperty(reactiveCache.recCache, 'logout', {
      // TODO add try-catch
      value: async function () {
        const isAuthenticated = await this.auth0.isAuthenticated()
        if (!isAuthenticated) return

        await this.auth0.logout({
          logoutParams: {
            returnTo: window.location.origin,
          },
        })

        this.client.isAuthenticated = false

        // Reset user information.
        this.client.user = {}

        // Change token, flush cache databases and start caching.
        // TODO the read all must be on the REC cache, not on the WoB client.
        this.client.setToken(null)
        this.clear()
        this.client.readAllRequest()
      },
    })

    // console.log('vue-wob-cache', reactiveCache)

    Vue.set(reactiveCache.recCache.index, 'ids', [])
    Vue.set(reactiveCache.recCache.geoCoords, 'ids', [])
    Vue.set(reactiveCache.recCache.types, 'ids', [])

    // TODO refactor/remove after testing...
    // Vue.set(reactiveCache.recCache.alarms, 'ids', [])
    // Vue.set(reactiveCache.recCache.exceptions, 'ids', [])
    // Vue.set(reactiveCache.recCache.impacts, 'ids', [])

    // Selector lists for alarms and exceptions.
    // All comprises arrays of IRIs, Iri[]
    Vue.set(reactiveCache.recCache.exceptionEvents, 'ids', [])
    Vue.set(reactiveCache.recCache.openExceptions, 'ids', [])
    Vue.set(reactiveCache.recCache.activeAlarms, 'ids', [])
    Vue.set(reactiveCache.recCache.alarmingAssets, 'ids', [])
    Vue.set(reactiveCache.recCache.impactedAssets, 'ids', [])

    // console.log('vue-wob-cache.set', reactiveCache)

    // new Test(reactiveCache.recCache.index.ids)

    const indexSelection = recCache.indexSelector.createSelection((ids) => {
      // Hypothesis, while the ids property of index is reacive it will only see the reference to argument ids which is the same at every invocation.
      // reactiveCache.recCache.index.ids = ids
      // Test a shallow copy instead, or splice. Time?
      // May be substitued by creating an object with adequate add and remove functions.
      // console.log(
      //   'vue-wob-cache.vue-wob-cache.install.index.ids.length',
      //   reactiveCache.recCache.index.ids.length
      // )

      reactiveCache.recCache.index.ids = [...ids]

      // console.log(
      //   'vue-wob-cache.vue-wob-cache.install.index',
      //   reactiveCache.recCache
      // )
    })
    reactiveCache.recCache.index.query =
      indexSelection.query.bind(indexSelection)
    Object.defineProperty(reactiveCache.recCache.index, 'size', {
      get() {
        return this.ids.length
      },
    })

    const geoCoordSelection = recCache.geoCoordSelector.createSelection(
      (ids) => {
        reactiveCache.recCache.geoCoords.ids = [...ids]
      }
    )
    reactiveCache.recCache.geoCoords.query =
      geoCoordSelection.query.bind(geoCoordSelection)
    Object.defineProperty(reactiveCache.recCache.geoCoords, 'size', {
      get() {
        return this.ids.length
      },
    })

    const typeSelection = recCache.typeSelector.createSelection((ids) => {
      reactiveCache.recCache.types.ids = [...ids]
    })
    reactiveCache.recCache.types.query = typeSelection.query.bind(typeSelection)
    Object.defineProperty(reactiveCache.recCache.types, 'list', {
      get() {
        return reactiveCache.recCache.typeSet
      },
    })

    // TODO being refactored. Remove when new implememtation is finalized.
    // const alarmSelection = recCache.typeSelector.createSelection((ids) => {
    //   reactiveCache.recCache.alarms.ids = [...ids]
    //   console.log(
    //     'vue-wob-cache.vue-wob-cache.install.alarms-callback.alarms',
    //     ids
    //   )

    //   const alarms = ids.map((a) => reactiveCache.recCache.read(a))
    //   const exceptions = alarms
    //     .map((a) => a.getValuesByName('https://w3id.org/rec#isPointOf'))
    //     .filter((values) => !!values)
    //     .reduce((prev, curr) => prev.concat(curr), [])
    //     .map((value) => value.value)
    //   reactiveCache.recCache.exceptions.ids = [...exceptions]

    //   // Recursive function to traverse all feeds relationships from an equipment.
    //   // Parameter ids is an array of Iris.
    //   // Returns array of all impacted individuals as id Iris.
    //   function impactsThroughFeeds(ids) {
    //     // TODO will eventually try to read individual that is not cached yet, leading to error.
    //     // For testing purposes undefined reads are filtered out.
    //     const equipments = ids
    //       .map((id) => reactiveCache.recCache.read(id))
    //       .filter((e) => !!e)
    //     console.log('EQUIPMENT', equipments)
    //     const feeds = equipments
    //       .map((e) => e.getValuesByName('https://w3id.org/rec#feeds'))
    //       .filter((values) => !!values)
    //       .reduce((prev, curr) => prev.concat(curr), [])
    //     if (feeds.length) {
    //       return equipments.map((e) => e.id).concat(impactsThroughFeeds(feeds))
    //     } else {
    //       return equipments.map((e) => e.id)
    //     }
    //   }
    //   // TODO the impacts will include the exceptions.
    //   // Refactor to only traverse layers after exceptions (equipment with alarms).
    //   reactiveCache.recCache.impacts.ids = impactsThroughFeeds(exceptions).map(
    //     (value) => value.value
    //   )
    // })
    // // Set a permanent query for the alarms that are monitored.
    // alarmSelection.query(Alarms)

    // Creates a callback for changes in the exception events.
    // Parameter ids is an array of iris, Iri[]
    // Used to update the list of assets directly and indirectly (through propagation) affected by an exception event.
    const exceptionSelection = recCache.typeSelector.createSelection((ids) => {
      reactiveCache.recCache.exceptionEvents.ids = [...ids]
      console.log(
        'vue-wob-cache.vue-wob-cache.install.events-callback.exception-events',
        ids
      )

      // Identify open exception events, ie exception events with no end time.
      // TODO the defined filter is necessary to cater for not yet read individuals.
      const openExceptions = ids
        .map((e) => reactiveCache.recCache.read(e))
        .filter((e) => !!e)
        .filter(
          (e) =>
            !e.getValuesByName(Iris.recEnd) ||
            !e.getValuesByName(Iris.recEnd).length
        )
      // TODO the mapping to ids may be embedded above but then the console cannot output. Refactor when tested.
      reactiveCache.recCache.openExceptions.ids = openExceptions.map(
        (e) => e.id
      )
      console.log(
        'vue-wob-cache.vue-wob-cache.install.events-callback.open-exception',
        openExceptions
      )

      // Identify active alarms, ie where end time for exception event has not been set.
      const activeAlarms = reactiveCache.recCache.openExceptions.ids
        .map((id) =>
          reactiveCache.recCache.queryEdges({
            target: id.value,
            label: 'https://w3id.org/rec#lastKnownValue',
          })
        )
        .filter((edge) => !!edge)
        .reduce((prev, curr) => prev.concat(curr), [])
        .map((edge) => edge.source)
      console.log(
        'vue-wob-cache.vue-wob-cache.install.events-callback.active-alarms',
        activeAlarms
      )
      reactiveCache.recCache.activeAlarms.ids = activeAlarms

      // Identify alarming assets, ie assets with active alarms. Array of IRIs, Iri[]
      const alarmingAssets = activeAlarms
        .map((a) => reactiveCache.recCache.read(a))
        .filter((a) => !!a)
        // TODO move property literal to Iris...
        .map((a) => a.getValuesByName('https://w3id.org/rec#isPointOf'))
        .filter((values) => !!values)
        .reduce((prev, curr) => prev.concat(curr), [])
      reactiveCache.recCache.alarmingAssets.ids = [...alarmingAssets]
      console.log(
        'vue-wob-cache.vue-wob-cache.install.events-callback.alarming-assets',
        alarmingAssets
      )

      // Recursive function to traverse all feeds relationships from an equipment.
      // Parameter ids is an array of IRIs, Iri[]
      // Returns array of all impacted equipment individuals as id Iris, Iri[]
      function impactedThroughFeeds(ids) {
        // TODO will eventually try to read individual that is not cached yet, leading to error.
        // For testing purposes undefined reads are filtered out.
        const equipments = ids
          .map((id) => reactiveCache.recCache.read(id))
          .filter((e) => !!e)
        const feeds = equipments
          // TODO move property literal to Iris...
          .map((e) => e.getValuesByName('https://w3id.org/rec#feeds'))
          .filter((values) => !!values)
          .reduce((prev, curr) => prev.concat(curr), [])
        if (feeds.length) {
          return equipments.map((e) => e.id).concat(impactedThroughFeeds(feeds))
        } else {
          return equipments.map((e) => e.id)
        }
      }

      reactiveCache.recCache.impactedAssets.ids =
        impactedThroughFeeds(alarmingAssets)
      console.log(
        'vue-wob-cache.vue-wob-cache.install.events-callback.impacted-assets',
        reactiveCache.recCache.impactedAssets.ids
      )
    })
    exceptionSelection.query([ExceptionEvent])

    console.log(
      'vue-wob-cache.vue-wob-cache.types',
      reactiveCache.recCache.types
    )

    vue.prototype.$wob = reactiveCache.recCache

    // console.log(
    //   'vue-wob-cache',
    //   Array.isArray(reactiveCache.recCache.index.ids)
    // )
  },
}
